module.exports = __webpack_public_path__ + "static/img/1.0de936c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/fg/1.png
// module id = 126
// module chunks = 2